<template>
  <div>
    TEST
    {{url}}
    <!-- <object rel="import" data="http://stackoverflow.com"></object> -->
    <iframe :src="url" class="if" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
    </iframe>
  </div>
</template>

<script>
export default {
  props: ['url'],
  // data: () => ({
  //   source: this.url
  // })
}
</script>

<style scoped>
.if {
  height: 100vh;
  width: 100vw;
  border: none;
  box-sizing: border-box;
}
</style>